<template>
	<v-app-bar
			app
			color="blue darken-4"
			dark>

		<v-toolbar-title>Entrance Exam</v-toolbar-title>
		<v-spacer></v-spacer>
		

		<v-toolbar-title>
			<v-btn text v-if="started">
				<v-icon left>mdi-clock</v-icon>
				{{ leadingZeroes(minutes) }}:{{ leadingZeroes(seconds) }}
			</v-btn>
		</v-toolbar-title>
	</v-app-bar>
</template>

<script>
// import Api from '../../services/api'
// import Notify from '../../services/notify'

export default {
		name: 'AppBar',
		props: ['drawer'],
		data() {
			return {
				timer: null,
				started: false,
				hours: 0,
				minutes: 0,
				seconds: 0,
			}
		},
		beforeDestroy () {
      clearInterval(this.timer)
    },
		created() {
			this.$root.$on('time-started', (timeDiff) => {
				this.started = true;
				this.minutes = timeDiff.i + (timeDiff.h * 60);
				this.seconds = timeDiff.s;
				this.timer = setInterval(() => {
					this.executeTimer();
				}, 1000);
			});

		},
		methods: {
			executeTimer() {
				this.seconds--;
				if(this.seconds < 0) {
					this.minutes--;
					this.seconds = 59;
				}

				if(this.minutes <= 0 && this.seconds <= 0) {
					this.minutes = 0;
					this.seconds = 0;
					history.go();
				}
			},

			leadingZeroes(digit) {
				if(digit < 10) {
					return '0' + digit;
				}
				return digit;
			}
		}
}
</script>